<section class="err-page">
  <div class="err-inner">
    <app-compass-hex mode="search" />
    <p class="err-code">404</p>
    <h1 class="err-title">Página no encontrada</h1>
    <p class="err-text">
      La página que buscas no existe, ha cambiado de dirección o aún no está
      publicada.
    </p>
    <a routerLink="/" class="err-btn">
      <i class="pi pi-arrow-left"></i> Volver al inicio
    </a>
    <p class="err-hint">
      ¿Buscabas algo concreto? Prueba en el
      <a routerLink="/ayuda">centro de ayuda</a>.
    </p>
  </div>
</section>
